import * as z from 'zod';

import { HistoricalTransactionId, LoanId, LoanImportId } from '../BrandedIds';

export const HistoricalTransactionType = z.enum(['payment', 'deposit', 'disbursement', 'draw']);
export type HistoricalTransactionType = z.infer<typeof HistoricalTransactionType>;

export interface HistoricalTransaction {
  id: HistoricalTransactionId;
  loanId: LoanId;
  loanImportId?: LoanImportId;
  type: HistoricalTransactionType;
  transactionId?: string;
  paymentDate: Date;
  dueDate?: Date;
  method?: string;
  description?: string;
  total: number;
  upb?: number;
  principal?: number;
  additionalPrincipal?: number;
  interest?: number;
  escrow?: number;
  suspense?: number;
  fee?: number;
  lateFee?: number;
  advance?: number;
  reserve?: number;
  holdback?: number;
  other?: number;
  createdAt: Date;
  updatedAt: Date;
}
